export const SentidoConst = {
  DeCimaParaBaixo: 'DeCimaParaBaixo',
  DeBaixoParaCima: 'DeBaixoParaCima',
  DaEsquerdaParaDireita: 'DaEsquerdaParaDireita',
  DeCimaParaBaixoProximaTabela: 'DeCimaParaBaixoProximaTabela',
  DeBaixoParaCimaProximaTabela: 'DeBaixoParaCimaProximaTabela',
};
